<template>
  <a-tag :color="color">{{ $t(`service_access_status.${text}`) }}</a-tag>
</template>

<script>

export default {
  name: 'ServiceAccessTag',
  props: {
    text: {
      type: String,
      default: 'processing'
    }
  },
  computed: {
    color () {
      switch (this.text) {
        case 'processing':
          return 'blue'
        case 'finished':
          return 'green'
        case 'timeout':
          return 'red'
        default:
          return ''
      }
    }
  }
}
</script>
